import React, {Component, PropTypes}   from 'react';
import { Provider }                    from 'react-redux';
import { Router }                       from 'react-router';

import { browserHistory }   from 'app/lib/browserHistory';
import { store }            from 'app/store';
import { setConfig }        from 'app/globals';
import bindCheckAuth        from 'app/lib/bindCheckAuth';
import * as api             from 'modules/app/repositories/AppRepository';
import { authenticate }     from 'modules/auth/actions';
import { fetchCompanyName } from 'modules/profile/actions';
import { IntlContainer }    from 'routes/app/containers/Intl';
import ProgressBar          from 'routes/app/components/ProgressBar';
import VersionCheck         from 'routes/app/components/VersionCheck/VersionCheck';


export default class RootComponent extends Component {

    static propTypes = {
        createRoutes: PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this.getConfig().then(() => {
            // Init Data
            store.dispatch(authenticate());
            store.dispatch(fetchCompanyName());
        });

        this.initRouting(props);

    }

    state = {
        loading: true
    };

    getConfig() {
        return api.getConfig()().then(config => {
            setConfig(config);
            this.setState({loading: false});
        });
    }

    initRouting(props) {
        const requireAccess = bindCheckAuth(store, (nextState, replace) => {
            replace('/login');
            //replaceState({
            //    next: nextState.location.pathname
            //}, '/login?next=' + nextState.location.pathname);
        }, (nextState, replace) => {
            replace('/login');
            //replaceState({},'/login'); //TODO: should redirect to /403
        });

        this.routes = props.createRoutes(requireAccess);

        //syncReduxAndRouter(history, store, state => {
        //    return state.get('route').toJS();
        //});
    }

    render() {
        if (this.state.loading) {
            return <div className="app-loader"><ProgressBar /></div>;
        }
        return (
            <Provider store={store}>
                <IntlContainer>
                    <div>
                        <VersionCheck />
                        <Router history={browserHistory}>{this.routes}</Router>
                    </div>
                </IntlContainer>
            </Provider>
        );
    }

}
